import "./BR_Academy_LP.css";
import BannerSlider from "./BrBanner";
import React from "react";
import { useState } from "react";
import BrTabContent from "./BrTabContent";
import { useNavigate, useLocation } from "react-router-dom";
import { useRef } from "react";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import axios from "axios";
import CONFIG from "../src/config";
import { FaTimes } from "react-icons/fa";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";

function BrAcademyLp() {
  const meta = metaConfig.bracademy;

  const [isOpen, setIsOpen] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const toggleMenu = () => setIsOpen(!isOpen);

  const [formData, setFormData] = useState({
    firstName: "",
    countryCode: "+91",
    email: "",
    phone: "",
    courseName: "",
  });
  console.log(formData, "formData");

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "email") {
      newValue = value.toLowerCase();
    } else if (name === "phone") {
      if (!/^\d{0,10}$/.test(value)) return; // Allow only 10-digit phone numbers
    } else if (name === "firstName") {
      newValue = value
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase());
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    // Remove error dynamically when user types correctly
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (newValue.trim() !== "") {
        delete newErrors[name];
      }
      return newErrors;
    });
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "Full name is required.";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^[6789]\d{9}$/.test(formData.phone)) {
      newErrors.phone = "number start with 6, 7, 8, or 9";
    }

    if (!formData.courseName.trim()) {
      newErrors.courseName = "Course name is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!validateForm()) {
      setIsSubmitting(false);
      return;
    }

    const phoneNumber = `${formData.countryCode}${formData.phone}`;
    const formDataToSend = {
      firstName: formData.firstName,
      email: formData.email,
      phone: phoneNumber,
      courseName: formData.courseName,
    };

    try {
      const response = await axios.post(
        `${CONFIG.BASE_URL}/career/apply/br-academy`,
        formDataToSend,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 201 || response.status === 200) {
        toast.success("Course Enquery submitted!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setShowForm(false);

        setFormData({
          firstName: "",
          email: "",
          phone: "",
          courseName: "",
          countryCode: "+91",
        });

        setErrors({});
      } else {
        toast.error(`Failed: ${response.data.error}`, {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred while submitting the application.", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // const closeAlert = () => {
  //   setShowAlert(false);
  // };

  return (
    <div className="br_wrap">
      <SEO {...meta} />
      <ToastContainer />

      <div class="container-fluid brbanner_wrap position-relative p-0">
        <div class="bnrbrnad mt-0">
          <div class="col-11 mx-auto item-align-end">
            <nav className="navbar">
              <div className="logo">
                <a href="https://www.bracadmy.com" class="p-0">
                  <img src="assets/img/Bracademy/brlogo.png" alt="Br academy" />
                </a>
              </div>

              <div className="menu-toggle" onClick={toggleMenu}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
              </div>
            </nav>
          </div>
        </div>
        <BannerSlider />

        <div>
          {/* Button to show form */}
          {!showForm && (
            <button
              className="btn btn-primary popupform"
              onClick={() => setShowForm(true)}
            >
              Register
            </button>
          )}

          {/* Form Display */}
          {showForm && (
            <div className="registeron_banner">
              <form autoComplete="off" onSubmit={handleSubmit}>
                <div className="custom-form-group d-block closepreview text-right">
                  <div className="text-right mt-3">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setShowForm(false)}
                    >
                      <FaTimes />
                    </button>
                  </div>
                </div>

                <div className="form-group_wrap custom-align col-md-12">
                  <div className="form-group filed_title col-md-4">
                    <h5 className="text-center">Get Course Offer</h5>
                  </div>
                </div>

                {/* FULL NAME */}
                <div className="form-group">
                  <label>Full Name:</label>
                  <input
                    type="text"
                    className="form-control border-1"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                  {errors.firstName && (
                    <p className="text-red-500 text-sm">{errors.firstName}</p>
                  )}
                </div>

                {/* EMAIL */}
                <div className="form-group">
                  <label>Email ID:</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control border-1"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <p className="text-red-500 text-sm">{errors.email}</p>
                  )}
                </div>

                {/* CONTACT */}
                <div className="form-group">
                  <label>Contact:</label>
                  <div className="contact-group">
                    <span
                      className="form-select border-1 countryCode"
                      name="countryCode"
                      value={formData.countryCode}
                      onChange={handleChange}
                    >
                      <option value="+91">IN +91</option>
                    </span>
                    <input
                      type="tel"
                      className="form-control border-1"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  {errors.phone && (
                    <p className="text-red-500 text-sm">{errors.phone}</p>
                  )}
                </div>

                {/* COURSES */}
                <div className="form-group">
                  <label>Courses:</label>
                  <select
                    className="form-control border-1"
                    name="courseName"
                    value={formData.courseName}
                    onChange={handleChange}
                  >
                    <option value="">Select a course</option>
                    <option value="Technical Course">Technical Course</option>
                    <option value="Non – Technical Course">
                      Non – Technical Course
                    </option>
                    <option value="Comunicative English">
                      Comunicative English
                    </option>
                    <option value="Soft Skills Training">
                      Soft Skills Training
                    </option>
                    <option value="Digital Marketing">Digital Marketing</option>
                    <option value="Financial Literacy">
                      Financial Literacy
                    </option>
                    <option value="Self Management">Self Management</option>
                    <option value="Corporate Training">
                      Corporate Training
                    </option>
                    <option value="Others">Others</option>
                  </select>
                  {errors.courseName && (
                    <p className="text-red-500 text-sm">{errors.courseName}</p>
                  )}
                </div>

                {/* SUBMIT BUTTON */}
                <div className="col-md-12 p-3 job_createion_cta text-center">
                  <button
                    className="btn-grad custom-btn-submit"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Wait Processing....." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          )}
        </div>

        <div class="br_bg p-4 h-100"></div>
      </div>

      <div class="br_containergradient ">
        <div class="container-fluid bg-mainblue">
          <div class="container">
            <div
              class="text-center mx-auto wow fadeInUp"
              data-wow-delay="0.2s"
              style={{ maxWidth: "800px" }}
            >
              <h3 class="pb-3 pt-3">
                <strong>Courses We Offer</strong>{" "}
              </h3>
              <p class="">
                Our Popular Courses at BR Academy provide students with the most
                advantageous learning experience which includes market-demanded
                skills and professional guidance. The carefully-designed lesson
                plan at BR Academy helps students reach both their academic and
                professional goals. Find your perfect learning path with our
                popular course selections. Separate training programs for
                colleges, corporates & schools{" "}
              </p>
            </div>
          </div>
        </div>

        {/* <!-- feature Start --> */}

        <div class="container-fluid ">
          <div class="container py-3">
            <BrTabContent />
          </div>
        </div>

        <div class="container-fluid featuressss  py-5">
          <div class="container">
            <div class="row g-4">
              <div className="col-md-5">
                <img
                  className="w-100"
                  src="assets/img/Bracademy/courseblog.png"
                  alt="BNR Cogniitec"
                />
              </div>
              <div className="col-md-7">
                <h4 class="text-left pb-3">
                  <strong>About BR Academy</strong>{" "}
                </h4>
                <p class="mycalss">
                  BR Academy serves students through more than classroom
                  textbooks along with standardized tests. The academy serves
                  students in their journey of potential discovery while
                  teaching essential skills for long-term success. The BR
                  Academy operates as a team that supports your educational
                  journey. Our learning philosophy embraces individual learning
                  varieties thus we provide customized educational assistance.
                  The instructors at BR Academy bring more than lesson guidance
                  to the students because they embrace a mentoring role where
                  they care deeply about student growth. The classroom at BR
                  Academy accepts students preparing for examinations together
                  with professionals seeking career growth plus anyone who
                  wishes to develop new abilities.
                </p>
                <p class="mycalss">
                  The educational setting we establish welcomes students to
                  express inquiries while they investigate fresh concepts in an
                  approachable atmosphere. Our purpose exists to create
                  confident learners who possess all the tools needed for dream
                  achievement through an enjoyable learning process.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid br_bg_background featuressss mt-5">
          <div class="container">
            <div class="row col-md-10 border-round p-3 mx-auto  g-4">
              <div className="col-md-7 mt-0 p-4">
                <div class="form-group">
                  <h3 class="text-white text-left">
                    We are happy to have you here
                  </h3>
                  <p class="mb-0 text-white">
                    You can reach us at{" "}
                    <a href="tel:+91  9952049494" className="brandcolor">
                      9952049494
                    </a>{" "}
                    or by email at
                    <a href="mailto:info@bracadmy.com" className="brandcolor">
                      {" "}
                      info@bracadmy.com
                    </a>
                    .
                  </p>
                </div>
              </div>
              <div className="col-md-5 mt-0 p-4">
                <div class="col-md-12 p-3 job_createion_cta">
                  <a href="https://www.bracadmy.com/study-aborad/">
                    <button type="submit" className="m-0  br_banner_cta">
                      Register Now
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid intern_inner py-5">
          <div class="container">
            <div class="text-center mx-auto wow fadeInUp" data-wow-delay="0.2s">
              <div class="row br_academy_featue pt-5 g-4">
                <h4 class="brbrand_text_color text-center">
                  <strong>Internship Courses</strong>
                </h4>
                <div class="col-xl-10  m-auto">
                  <div
                    class="col-md-6 d-inline-block col-lg-6 col-xl-4 wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div class="feature-item ">
                      <div class="feature-icon mb-3">
                        <img
                          src="assets/img/Bracademy/intern1.png"
                          alt="BNR Cogniitec"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 col-lg-6 d-inline-block col-xl-4 wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    <div class="feature-item ">
                      <div class="feature-icon mb-3">
                        <img
                          className="w-100"
                          src="assets/img/Bracademy/intern2.png"
                          alt="BNR Cogniitec"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class=" col-md-6 col-lg-6 d-inline-block col-xl-4 wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div class="feature-item ">
                      <div class="feature-icon mb-3">
                        <img
                          className="w-100"
                          src="assets/img/Bracademy/intern3.png"
                          alt="BNR Cogniitec"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 col-lg-6 d-inline-block col-xl-4 wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div class="feature-item ">
                      <div class="feature-icon mb-3">
                        <img
                          className="w-100"
                          src="assets/img/Bracademy/intern4.png"
                          alt="BNR Cogniitec"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 col-lg-6 d-inline-block col-xl-4 wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div class="feature-item">
                      <div class="feature-icon mb-3">
                        <img
                          className="w-100"
                          src="assets/img/Bracademy/intern5.png"
                          alt="BNR Cogniitec"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-md-6 col-lg-6 d-inline-block col-xl-4 wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    <div class="feature-item">
                      <div class="feature-icon mb-3">
                        <img
                          className="w-100"
                          src="assets/img/Bracademy/intern6.png"
                          alt="BNR Cogniitec"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="container-fluid ">
          <div class="container">
            <div class="row g-4 align-items-center">
              <div
                class="text-center mx-auto  pb-5 wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <p class="brbrand_text_color pb-3">
                  During our Internship Course you will receive practical
                  experience in the area you selected. Students can develop
                  important professional abilities while building professional
                  contacts by completing assignments from real-world projects.
                  You will get individual mentorship combined with guidance from
                  practitioners in your field. You can build a future career
                  through hands-on training as well as portfolio-building
                  practices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Copyright Start --> */}
      <div class="container-fluid  br_copyright py-1">
        <div class="container">
          <div class="row g-4 align-items-center m-auto p-0">
            <div class="col-md-6 text-center text-body  p-0 m-auto ">
              <a class="" href="https://www.bracadmy.com/privacy-policy/">
                Privacy Policy
              </a>{" "}
              |{" "}
              <a class="" href="https://www.bracadmy.com/terms-and-conditions/">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Copyright End --> */}

      {/* <!-- Back to Top --> */}
      <button
        className="btn btn-secondary btn-lg-square rounded-circle back-to-top"
        onClick={() => window.scrollTo(0, 0)}
      >
        <i className="fa fa-arrow-up"></i>
      </button>
    </div>
  );
}

export default BrAcademyLp;
